export default __webpack_public_path__ + "static/media/mercadopago.7ae4fa17.xcf";